import React from 'react';
import styles from './boon-line.styles';
import { flattenClassesToString, resolveProperty, toBorderClass } from './style-sheet';

type side = 'left' | 'right';

interface BoonLineProps {
    lineColor: string;
    lineStyle?: string;
    side: side;
    height?: string;
    width: string;
    display?: string;
    addtlContainerClasses?: string;
}

const BoonLine: React.FC<BoonLineProps> = props => {
    const beforeCss = props.side === 'left' ? 'boon-line-left-before' : 'boon-line-right-before';
    const afterCss = props.side === 'left' ? 'boon-line-left-after' : 'boon-line-right-after';
    const edgeBorder = props.side === 'left' ? 'border-l' : 'border-r';

    const height = props.height ? props.height : 'h-full';
    const borderColor = toBorderClass(resolveProperty('lineColor', props));
    const borderLineStyle = resolveProperty('lineStyle', props) || 'border-solid';
    const lineWidth = props.width || 'w-8';
    const display = props.display ? props.display : 'block';

    const containerStyle = flattenClassesToString('relative', height, display, lineWidth, props.addtlContainerClasses);
    const bottomFixStyle = flattenClassesToString(
        'block absolute w-full h-1/2 border-b halfpx-down',
        beforeCss,
        borderColor,
        borderLineStyle
    );
    const bottomRightFixStyle = flattenClassesToString(
        'block absolute w-full h-1/2 border-b halfpx-down',
        edgeBorder,
        afterCss,
        borderColor,
        borderLineStyle
    );
    const rightFixStyle = flattenClassesToString(
        'block absolute w-full h-1/2',
        edgeBorder,
        afterCss,
        borderColor,
        borderLineStyle
    );

    return (
        <React.Fragment>
            <style jsx>{styles}</style>
            <div className={containerStyle}>
                <div className={bottomFixStyle}></div>
                <div className={bottomRightFixStyle}></div>
                <div className={rightFixStyle}></div>
            </div>
        </React.Fragment>
    );
};

export default BoonLine;
